const isSupported = (win = window) => {
  if (
    win.webkit &&
    win.webkit.messageHandlers &&
    win.webkit.messageHandlers.KlarnaNativeHookMessageHandler
  ) {
    // If iOS' WKWebView
    return true
    // If iOS' UIWebView or Android's WebView
  } else if (win.KlarnaNativeHookMessageHandler) {
    return true
  }
  return false
}

export default isSupported
